export default __webpack_public_path__ + "static/media/campos-localestoque.f1a67e48.png";